import { useState } from "react";
import { BarcodeScanner } from "react-barcode-detection";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { AiOutlineRedo } from "react-icons/ai";
import { ScannedResult, ScannerWrapper } from "./scan.styled";
import "./app.css";

const bb = {
  stroke: "#fff",
  radii: 10,
  lineWidth: 4,
  gap: 0.5,
  margin: 0.1,
};
const cp = {
  fill: "rgba(0, 255, 0, 0.4)",
};

export default function ReactQRBarcodeScanner({ onDetected }) {
  return typeof BarcodeDetector === "function" ? (
    <CamApp onDetected={onDetected} />
  ) : (
    <QRBarcodeScanner onDetected={onDetected} />
  );
}

export function CamApp({ onDetected }) {
  return (
    <div className="App">
      <h2>Scanner 1</h2>
      <FindAndStop
        use="api,quirc,jsqr"
        accept="qr_code,code_128,code_39,code_93"
        onDetected={onDetected}
      />
    </div>
  );
}

function FindAndStop({ use, accept, onDetected }) {
  const [data, setData] = useState(null);
  const onData = (data) => {
    setData(data);
    onDetected?.(data);
  };
  const clearData = () => {
    setData(null);
    onDetected?.(null);
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#FFF",
        }}
      >
        {data ? (
          <BarcodeResult data={data} clearData={clearData} />
        ) : (
          <BarcodeScanner
            boundingBox={bb}
            cornerPoints={cp}
            accept={accept}
            use={use}
            clearInterval={500}
            onData={onData}
          >
            <NoCamera />
          </BarcodeScanner>
        )}
      </div>
    </>
  );
}

export function QRBarcodeScanner({ onDetected }) {
  const [data, setData] = useState(null);

  const updateScanResult = (err, result) => {
    if (result?.text) {
      setData(result.text);
      onDetected?.(result.text);
    }
  };

  const clearData = () => {
    setData(null);
    onDetected?.(null);
  };

  return (
    <ScannerWrapper>
      <h2>Scanner 2</h2>
      {!data && (
        <BarcodeScannerComponent
          width={window.innerWidth > 500 ? 500 : window.innerWidth}
          height={window.innerHeight > 500 ? 500 : window.innerHeight}
          onUpdate={updateScanResult}
        />
      )}
      {data && <BarcodeResult data={data} clearData={clearData} />}
    </ScannerWrapper>
  );
}

function BarcodeResult({ data, clearData }) {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <ScannedResult
        status="success"
        title="Scanned"
        subTitle={data}
        extra={[
          <button
            key="reopen-scan-btn"
            className="bbtn"
            onClick={clearData}
            style={{ textTransform: "none" }}
          >
            <AiOutlineRedo /> Re-open Scanner
          </button>,
        ]}
      />
    </div>
  );
}

function NoCamera() {
  return (
    <div className="no-camera">
      <div className="sign">&#9940;</div>
    </div>
  );
}
